import { type useAuthStore } from '@/stores/AuthStore'
import { type useConfigStore } from '@/stores/ConfigStore'
import * as Sentry from '@sentry/capacitor'
import * as SentryVue from '@sentry/vue'
import { watch } from 'vue'
import { type App } from 'vue'

function init(mode: string, app: App) {
  if (['development', 'dev'].includes(mode)) {
    console.log('not initializing Sentry in dev mode')
    return
  }
  const versionInfo =
    import.meta.env.CLOCKIN_APP_VERSION.release +
    '-' +
    import.meta.env.VITE_GIT_COMMIT_HASH // in vite.config.mts we use the same version string to upload the sourcemaps

  Sentry.init(
    {
      app,
      dsn: 'https://e5d19572e4e84e76b1ada54ca2c93a3c@o360508.ingest.sentry.io/6654778',
      environment: mode,
      release: versionInfo,
      beforeSend(event) {
        if (
          event.message &&
          event.message.includes(
            'ResizeObserver loop completed with undelivered notifications.',
          )
        ) {
          return null
        }
        return event
      },
    },
    SentryVue.init,
  )
}

function watchConfig(
  authStore: ReturnType<typeof useAuthStore>,
  configStore: ReturnType<typeof useConfigStore>,
) {
  watch(
    () => authStore.device_type,
    (deviceType) => Sentry.setTag('device_type', deviceType),
  )
  watch(
    () => configStore.host,
    (host) => Sentry.setTag('host', host),
  )
  watch(
    () => configStore.company_id,
    (companyId) => Sentry.setTag('company_id', companyId),
  )
  watch(
    () => configStore.device_id,
    (deviceId) => Sentry.setTag('device_id', deviceId),
  )
  watch(
    () => configStore.user_id,
    (userId) => Sentry.setTag('user_id', userId),
  )
}

function report(error: Error) {
  Sentry.captureException(error)
  console.error(error)
}

export { init, watchConfig, report }
